import React from "react";
import styles from "./AlertModal.module.css";

const AlertModal = ({ message, onClose }) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox}>
        <p>{message}</p>
        <button onClick={onClose} className={styles.modalButton}>
          OK
        </button>
      </div>
    </div>
  );
};

export default AlertModal;
